import React from 'react';
import './App.css';
import Orb from './components/orb';
import BlurText from './components/BlurText';

const App: React.FC = () => {
  return (
    <>
     <div style={{ width: '100%', height: '100vh', position: 'relative' }}>
       {/* Background Prism Effect */}
       <div style={{
         position: 'absolute',
         top: '45%', // 与BlurText相同的垂直位置
         left: '50%',
         transform: 'translate(-50%, -50%)',
         width: '100%',
         height: '100%',
         zIndex: 1
       }}>
         <Orb
           hoverIntensity={0.5}
           rotateOnHover={true}
           hue={0}
           forceHoverState={false}
         />
       </div>
       
       {/* BlurText Component */}
       <div style={{ 
         position: 'absolute', 
         top: '45%', // 从50%调整到45%，让内容更靠上
         left: '50%', 
         transform: 'translate(-50%, -50%)',
         zIndex: 10,
         width: '100%',
         maxWidth: '95vw', // 确保在移动端不会超出屏幕
         padding: '0 0.5rem' // 添加左右内边距
       }}>
         <BlurText text="OuuuuO" 
         delay={150}
         animateBy="letters"
         direction="top"
         className="text-2xl mb-8"
         />
       </div>
     </div>
     
     {/* Copyright Footer */}
     <div style={{
       position: 'fixed',
       bottom: '15px',
       left: '50%',
       transform: 'translateX(-50%)',
       textAlign: 'center',
       color: 'rgba(255, 255, 255, 0.6)',
       fontSize: '12px',
       zIndex: 20,
       fontFamily: 'Arial, sans-serif'
     }}>
       <div>
         © 2025 ouo.nz - Built on{' '}
         <a 
           href="https://react.dev" 
           target="_blank" 
           rel="noopener noreferrer"
           style={{ 
             color: 'rgba(255, 255, 255, 0.8)', 
             textDecoration: 'none',
             borderBottom: '1px solid transparent',
             transition: 'all 0.3s ease'
           }}
           onMouseEnter={(e) => {
             const target = e.target as HTMLAnchorElement;
             target.style.borderBottomColor = 'rgba(255, 255, 255, 0.8)';
             target.style.color = '#ffffff';
           }}
           onMouseLeave={(e) => {
             const target = e.target as HTMLAnchorElement;
             target.style.borderBottomColor = 'transparent';
             target.style.color = 'rgba(255, 255, 255, 0.8)';
           }}
         >
           React
         </a>
       </div>
       <div style={{ marginTop: '4px' }}>
         Powered by{' '}
         <a 
           href="https://pages.cloudflare.com" 
           target="_blank" 
           rel="noopener noreferrer"
           style={{ 
             color: 'rgba(255, 255, 255, 0.8)', 
             textDecoration: 'none',
             borderBottom: '1px solid transparent',
             transition: 'all 0.3s ease'
           }}
           onMouseEnter={(e) => {
             const target = e.target as HTMLAnchorElement;
             target.style.borderBottomColor = 'rgba(255, 255, 255, 0.8)';
             target.style.color = '#ffffff';
           }}
           onMouseLeave={(e) => {
             const target = e.target as HTMLAnchorElement;
             target.style.borderBottomColor = 'transparent';
             target.style.color = 'rgba(255, 255, 255, 0.8)';
           }}
         >
           Cloudflare Pages
         </a>
       </div>
     </div>
     
     </>
  );
};

export default App;



